import React from 'react'
import ImageSlider from '../Components/ImageSlider'
import slide1 from '../Images/slide1.png';

import Header from '../Components/Header';

import visionImage from '../Images/5147393.png'; // Add your vision image
import missionImage from '../Images/2376627.png';
import About from './About';
import BusinessModule from './BusinessModule';
import Services from './Services';
import Projects from './Projects';
import Contact from './Contact';
import Footer from '../Components/Footer';
import OurTeam from './OurTeam';
import Team from './Team';
import CombinedCards from '../Components/CombinedCards';
import OurServices from '../Components/OurServices';
import BusinessM from '../Components/BusinessM';
import NewHome from './NewHome';
import CompanyOverview from './CompanyOverview';
import USAMap from './USAMap';
import { AppConstant } from '../AppConstant';



const Home = () => {

  const imageList = [slide1];
  const appStyle = {
    background: '#f9fafc',
    // background: 'red',

    // backgroundImage: AppConstant.backgroundtextilerdesign,

    // minHeight: '100vh',
    color: 'black', // optional: ensure text is readable
  };
  const sectionStyle = {
    minHeight: '100vh',
    overflow: 'hidden',
    paddingBottom: '5%',
   backgroundColor:'white'
    // paddingTop: '100px',
  };
  <style
    dangerouslySetInnerHTML={{
      __html: `
      /* Print styles */
      @media print {
        body {
          -webkit-print-color-adjust: exact !important;
          print-color-adjust: exact !important;
          margin: 0;
          padding: 0;
        }
        .print-section {
          height: 1122px !important;
          page-break-after: always !important;
          page-break-inside: avoid !important;
          break-inside: avoid !important;
          overflow: hidden !important;
        }
      }

      /* Responsive screen styles */
      .print-section {
        width: 100%;
        margin: 0 auto;
        overflow: hidden;
      }

      /* Small screens */
      @media (max-width: 768px) {
        .print-section {
          height: auto; /* let it expand based on content */
          padding: 20px;
        }
      }

      /* Medium screens */
      @media (min-width: 769px) and (max-width: 1200px) {
        .print-section {
          height: 800px; /* example height */
          padding: 40px;
        }
      }

      /* Large screens */
      @media (min-width: 1201px) {
        .print-section {
          height: 1122px; /* your original print height as default */
          padding: 60px;
        }
      }
    `,
    }}
  />


  return (
    <div>
      <Header />




      <div style={{}}>
        <NewHome />
      </div>


      <div className="print-section" style={sectionStyle}>
        <CompanyOverview />
      </div>



      <Footer />



    </div>
  )
}

const styles = {
  container: {
    padding: '4rem 2rem',
    fontFamily: 'Arial, sans-serif',
    backgroundColor: '#f9fafc',
    color: '#333',
    lineHeight: '1.6',
  },
  section: {
    marginBottom: '3rem',
    maxWidth: '100%',
  },
  heading: {
    fontSize: '2rem',
    fontWeight: 'bold',
    color: "#0A1733"
  },
  orangeText: {
    color: '#f37021',
  },
  paragraph: {
    fontSize: '1rem',
    marginTop: '1rem',
    color: "#0A1733"
    // width:'90%'
  },
  missionWrapper: {
    display: 'flex',
    justifyContent: 'flex-start', // 👈 moves to right
  },
  missiondarkBox: {

    // background: 'linear-gradient(to right, #0f2027, #203a43, #2c5364)',
    color: '#070707ff',
    padding: '2rem',
    borderRadius: '0 2rem 2rem 0 ',
    maxWidth: '800px',
    textAlign: 'left',
    background: 'linear-gradient(145deg, rgba(255,255,255,0.1), rgba(255,255,255,0.05))',
    borderTop: '4px solid #f37021',
    borderRight: '4px solid #f37021',
    borderBottom: '4px solid #f37021',
    // borderRight: 'none',  // 🚀 removes right side border
    boxShadow: '0 8px 20px rgba(0,0,0,0.1)',
    backdropFilter: 'blur(8px)',
    transition: 'transform 0.3s ease, box-shadow 0.3s ease',
  },

  // Vision box only
  visionWrapper: {
    display: 'flex',
    justifyContent: 'flex-end', // 👈 moves to right
  },
  visionContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '2rem',
    flexWrap: 'wrap', // ensures responsiveness
  },
  visionImageWrapper: {
    flex: '1 1 300px',
    textAlign: 'center',
  },
  visionImage: {
    maxWidth: '100%',
    height: 'auto',
    borderRadius: '1rem',

  },

  darkBox: {

    // background: 'linear-gradient(to right, #0f2027, #203a43, #2c5364)',
    color: '#070707ff',
    padding: '2rem',
    borderRadius: '2rem 0 0 2rem',
    maxWidth: '800px',
    textAlign: 'right',
    background: 'linear-gradient(145deg, rgba(255,255,255,0.1), rgba(255,255,255,0.05))',
    borderTop: '4px solid #f37021',
    borderLeft: '4px solid #f37021',
    borderBottom: '4px solid #f37021',
    borderRight: 'none',  // 🚀 removes right side border
    boxShadow: '0 8px 20px rgba(0,0,0,0.1)',
    backdropFilter: 'blur(8px)',
    transition: 'transform 0.3s ease, box-shadow 0.3s ease',
  },
  darkHeading: {
    color: '#f37021',
    fontSize: '1.5rem',
    fontWeight: 'bold',
    marginBottom: '1rem',
  },
};


export default Home